/* sk.js - Schnittkunde.
   Umschalter zwischen Rind und Schwein, die Tafel neben der Schnittgrafik und
   das Anspringen einzelner Teilstuecke ueber die Adresse.

   Ohne dieses Skript bleibt die Seite vollstaendig: beide Tierarten stehen im
   Dokument, jede Flaeche im Umriss ist ein Link auf das Teilstueck in der
   Liste. Hier kommt nur die Bequemlichkeit dazu. */
(function () {
  'use strict';

  var TIERE = ['rind', 'schwein'];
  var daten = [];
  var aktivesTier = 'rind';

  function alle(sel, wurzel) { return Array.prototype.slice.call((wurzel || document).querySelectorAll(sel)); }

  function datenLaden() {
    var block = document.querySelector('[data-sk-daten]');
    if (!block) return;
    try { daten = JSON.parse(block.textContent) || []; } catch (e) { daten = []; }
  }

  function stueck(tier, id) {
    for (var i = 0; i < daten.length; i++) {
      if (daten[i].tier === tier && daten[i].id === id) return daten[i];
    }
    return null;
  }

  /* ---- Umschalter ------------------------------------------------------ */

  function tierSetzen(tier, fokus) {
    if (TIERE.indexOf(tier) === -1) return;
    aktivesTier = tier;

    alle('[data-sk-panel]').forEach(function (p) {
      var an = p.getAttribute('data-sk-panel') === tier;
      if (an) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    });

    alle('[data-sk-toggle] button').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sk-tier') === tier ? 'true' : 'false');
    });

    if (fokus) {
      var knopf = document.querySelector('[data-sk-toggle] button[data-sk-tier="' + tier + '"]');
      if (knopf) knopf.focus();
    }
  }

  function umschalterBinden() {
    alle('[data-sk-toggle]').forEach(function (gruppe) {
      gruppe.addEventListener('click', function (ev) {
        var knopf = ev.target.closest('button[data-sk-tier]');
        if (!knopf) return;
        tierSetzen(knopf.getAttribute('data-sk-tier'), false);
      });
    });
  }

  /* ---- Tafel ----------------------------------------------------------- */

  function el(tag, klasse, text) {
    var n = document.createElement(tag);
    if (klasse) n.className = klasse;
    if (text != null) n.textContent = text;
    return n;
  }

  function pillReihe(wert, label) {
    if (!wert || wert === '-') return null;
    var box = document.createDocumentFragment();
    box.appendChild(el('p', 'sk-label', label));
    var reihe = el('div', 'sk-pills');
    wert.split('~').forEach(function (w) { reihe.appendChild(el('span', 'sk-pill', w)); });
    box.appendChild(reihe);
    return box;
  }

  function wertReihe(label, stufe) {
    var zeile = el('div', 'sk-wert');
    zeile.appendChild(el('span', null, label));
    var punkte = el('div', 'sk-punkte');
    var n = parseInt(stufe, 10) || 0;
    for (var i = 1; i <= 5; i++) {
      punkte.appendChild(el('span', 'sk-punkt' + (i <= n ? ' is-on' : '')));
    }
    zeile.appendChild(punkte);
    return zeile;
  }

  function tafelFuellen(d) {
    var tafel = document.querySelector('[data-sk-tafel="' + d.tier + '"]');
    if (!tafel) return;
    var ziel = tafel.querySelector('[data-sk-tafel-inhalt]');
    var leer = tafel.querySelector('[data-sk-leer]');
    if (!ziel) return;

    ziel.textContent = '';

    var kopf = el('div', 'sk-tafel__kopf');
    kopf.appendChild(el('span', 'sk-tafel__nr', d.nr));
    kopf.appendChild(el('h3', 'sk-h3', d.name));
    ziel.appendChild(kopf);

    var neben = [];
    if (d.alt && d.alt !== '-') neben.push('Auch ' + d.alt.split('~').join(', '));
    if (d.viertel && d.viertel !== '-') neben.push(d.viertel);
    if (neben.length) ziel.appendChild(el('p', 'sk-tafel__alt', neben.join(' · ')));

    var wo = [d.lage, d.kurz].filter(function (x) { return x && x !== '-'; }).join(' ');
    if (wo) ziel.appendChild(el('p', 'sk-tafel__wo', wo));

    var werte = el('div', 'sk-werte');
    werte.appendChild(wertReihe('Fett', d.fett));
    werte.appendChild(wertReihe('Faser', d.faser));
    werte.appendChild(wertReihe('Zartheit', d.zart));
    ziel.appendChild(werte);

    /* Zuschnitte: Was es im Shop gibt, wird zur Kachel mit Link. Was wir nicht
       dauerhaft fuehren, steht darunter ohne Link, damit niemand ins Leere
       klickt. Dieselbe Trennung wie in der Teilstueckliste. */
    var mit = (d.zuschnitte || []).filter(function (z) { return z.u; });
    var ohne = (d.zuschnitte || []).filter(function (z) { return !z.u; });

    if (mit.length) {
      ziel.appendChild(el('p', 'sk-label', 'Daraus schneiden wir'));
      var reihe = el('div', 'sk-pills');
      mit.forEach(function (z) {
        var a = el('a', 'sk-pill', z.n);
        a.setAttribute('href', z.u);
        reihe.appendChild(a);
      });
      ziel.appendChild(reihe);
    }
    if (ohne.length) {
      var hin = el('p', 'sk-karte__kein');
      hin.style.marginTop = mit.length ? '8px' : '0';
      hin.textContent = 'Nicht dauerhaft im Sortiment: ' + ohne.map(function (z) { return z.n; }).join(', ');
      ziel.appendChild(hin);
    }
    var ga = pillReihe(d.garen, 'So wird es gegart');
    if (ga) ziel.appendChild(ga);

    if (d.tipp && d.tipp !== '-') {
      var tipp = el('div', 'sk-tipp');
      var p = el('p');
      p.appendChild(el('b', null, 'Aus der Metzgerei'));
      p.appendChild(document.createTextNode(d.tipp));
      tipp.appendChild(p);
      ziel.appendChild(tipp);
    }

    if (d.url) {
      var a = el('a', 'sk-pill', 'Im Shop ansehen');
      a.setAttribute('href', d.url);
      var box = el('div', 'sk-pills');
      box.style.marginTop = '16px';
      box.appendChild(a);
      ziel.appendChild(box);
    }

    ziel.removeAttribute('hidden');
    if (leer) leer.setAttribute('hidden', '');
  }

  function auswahlSetzen(tier, id, scrollen) {
    var d = stueck(tier, id);
    if (!d) return false;
    if (tier !== aktivesTier) tierSetzen(tier, false);

    alle('[data-sk-area]').forEach(function (a) {
      var an = a.getAttribute('data-sk-area') === tier + ':' + id;
      alle('.sk-area', a).forEach(function (f) { f.classList.toggle('is-active', an); });
      if (an) { a.setAttribute('aria-current', 'true'); } else { a.removeAttribute('aria-current'); }
    });

    tafelFuellen(d);

    if (scrollen) {
      var tafel = document.querySelector('[data-sk-tafel="' + tier + '"]');
      if (tafel && window.matchMedia('(max-width: 768.98px)').matches) {
        tafel.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
    return true;
  }

  function flaechenBinden() {
    alle('[data-sk-area]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var teile = (a.getAttribute('data-sk-area') || '').split(':');
        if (teile.length !== 2) return;
        /* Der Link bleibt als Rueckfall bestehen. Greift die Tafel, bleiben wir
           auf der Stelle statt nach unten in die Liste zu springen. */
        if (auswahlSetzen(teile[0], teile[1], true)) ev.preventDefault();
      });
    });
  }

  /* ---- Adresse --------------------------------------------------------- */

  function ausHash() {
    var h = (window.location.hash || '').replace('#', '');
    var m = /^sk-(rind|schwein)-(.+)$/.exec(h);
    if (!m) return;
    var panel = document.querySelector('[data-sk-panel="' + m[1] + '"]');
    if (panel) tierSetzen(m[1], false);
    auswahlSetzen(m[1], m[2], false);
    var ziel = document.getElementById(h);
    if (ziel && ziel.scrollIntoView) ziel.scrollIntoView({ block: 'start' });
  }

  function start() {
    datenLaden();
    umschalterBinden();
    flaechenBinden();
    tierSetzen('rind', false);
    ausHash();
    window.addEventListener('hashchange', ausHash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
